function $e(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var i = 0, t = Array(n); i < n; i++) t[i] = e[i];
  return t;
}
function Er(e) {
  if (Array.isArray(e)) return $e(e);
}
function On(e, n, i, t, a, l, m) {
  try {
    var g = e[l](m), T = g.value;
  } catch (V) {
    return void i(V);
  }
  g.done ? n(T) : Promise.resolve(T).then(t, a);
}
function Le(e) {
  return function() {
    var n = this, i = arguments;
    return new Promise(function(t, a) {
      var l = e.apply(n, i);
      function m(T) {
        On(l, t, a, m, g, "next", T);
      }
      function g(T) {
        On(l, t, a, m, g, "throw", T);
      }
      m(void 0);
    });
  };
}
function _r(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Mr(e, n) {
  for (var i = 0; i < n.length; i++) {
    var t = n[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, An(t.key), t);
  }
}
function Pr(e, n, i) {
  return i && Mr(e, i), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Cr(e, n, i) {
  return (n = An(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function Dr(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ar() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tn(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, t);
  }
  return i;
}
function F(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Tn(Object(i), !0).forEach(function(t) {
      Cr(e, t, i[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Tn(Object(i)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
    });
  }
  return e;
}
function ne() {
  ne = function() {
    return n;
  };
  var e, n = {}, i = Object.prototype, t = i.hasOwnProperty, a = Object.defineProperty || function(c, s, d) {
    c[s] = d.value;
  }, l = typeof Symbol == "function" ? Symbol : {}, m = l.iterator || "@@iterator", g = l.asyncIterator || "@@asyncIterator", T = l.toStringTag || "@@toStringTag";
  function V(c, s, d) {
    return Object.defineProperty(c, s, {
      value: d,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), c[s];
  }
  try {
    V({}, "");
  } catch {
    V = function(s, d, y) {
      return s[d] = y;
    };
  }
  function D(c, s, d, y) {
    var v = s && s.prototype instanceof me ? s : me, S = Object.create(v.prototype), P = new ye(y || []);
    return a(S, "_invoke", {
      value: Be(c, d, P)
    }), S;
  }
  function X(c, s, d) {
    try {
      return {
        type: "normal",
        arg: c.call(s, d)
      };
    } catch (y) {
      return {
        type: "throw",
        arg: y
      };
    }
  }
  n.wrap = D;
  var M = "suspendedStart", A = "suspendedYield", pe = "executing", j = "completed", Z = {};
  function me() {
  }
  function b() {
  }
  function I() {
  }
  var ee = {};
  V(ee, m, function() {
    return this;
  });
  var re = Object.getPrototypeOf, W = re && re(re(Ne([])));
  W && W !== i && t.call(W, m) && (ee = W);
  var q = I.prototype = me.prototype = Object.create(ee);
  function Ce(c) {
    ["next", "throw", "return"].forEach(function(s) {
      V(c, s, function(d) {
        return this._invoke(s, d);
      });
    });
  }
  function ae(c, s) {
    function d(v, S, P, k) {
      var U = X(c[v], c, S);
      if (U.type !== "throw") {
        var ie = U.arg, ce = ie.value;
        return ce && typeof ce == "object" && t.call(ce, "__await") ? s.resolve(ce.__await).then(function($) {
          d("next", $, P, k);
        }, function($) {
          d("throw", $, P, k);
        }) : s.resolve(ce).then(function($) {
          ie.value = $, P(ie);
        }, function($) {
          return d("throw", $, P, k);
        });
      }
      k(U.arg);
    }
    var y;
    a(this, "_invoke", {
      value: function(v, S) {
        function P() {
          return new s(function(k, U) {
            d(v, S, k, U);
          });
        }
        return y = y ? y.then(P, P) : P();
      }
    });
  }
  function Be(c, s, d) {
    var y = M;
    return function(v, S) {
      if (y === pe) throw Error("Generator is already running");
      if (y === j) {
        if (v === "throw") throw S;
        return {
          value: e,
          done: !0
        };
      }
      for (d.method = v, d.arg = S; ; ) {
        var P = d.delegate;
        if (P) {
          var k = ge(P, d);
          if (k) {
            if (k === Z) continue;
            return k;
          }
        }
        if (d.method === "next") d.sent = d._sent = d.arg;
        else if (d.method === "throw") {
          if (y === M) throw y = j, d.arg;
          d.dispatchException(d.arg);
        } else d.method === "return" && d.abrupt("return", d.arg);
        y = pe;
        var U = X(c, s, d);
        if (U.type === "normal") {
          if (y = d.done ? j : A, U.arg === Z) continue;
          return {
            value: U.arg,
            done: d.done
          };
        }
        U.type === "throw" && (y = j, d.method = "throw", d.arg = U.arg);
      }
    };
  }
  function ge(c, s) {
    var d = s.method, y = c.iterator[d];
    if (y === e) return s.delegate = null, d === "throw" && c.iterator.return && (s.method = "return", s.arg = e, ge(c, s), s.method === "throw") || d !== "return" && (s.method = "throw", s.arg = new TypeError("The iterator does not provide a '" + d + "' method")), Z;
    var v = X(y, c.iterator, s.arg);
    if (v.type === "throw") return s.method = "throw", s.arg = v.arg, s.delegate = null, Z;
    var S = v.arg;
    return S ? S.done ? (s[c.resultName] = S.value, s.next = c.nextLoc, s.method !== "return" && (s.method = "next", s.arg = e), s.delegate = null, Z) : S : (s.method = "throw", s.arg = new TypeError("iterator result is not an object"), s.delegate = null, Z);
  }
  function se(c) {
    var s = {
      tryLoc: c[0]
    };
    1 in c && (s.catchLoc = c[1]), 2 in c && (s.finallyLoc = c[2], s.afterLoc = c[3]), this.tryEntries.push(s);
  }
  function Ie(c) {
    var s = c.completion || {};
    s.type = "normal", delete s.arg, c.completion = s;
  }
  function ye(c) {
    this.tryEntries = [{
      tryLoc: "root"
    }], c.forEach(se, this), this.reset(!0);
  }
  function Ne(c) {
    if (c || c === "") {
      var s = c[m];
      if (s) return s.call(c);
      if (typeof c.next == "function") return c;
      if (!isNaN(c.length)) {
        var d = -1, y = function v() {
          for (; ++d < c.length; ) if (t.call(c, d)) return v.value = c[d], v.done = !1, v;
          return v.value = e, v.done = !0, v;
        };
        return y.next = y;
      }
    }
    throw new TypeError(typeof c + " is not iterable");
  }
  return b.prototype = I, a(q, "constructor", {
    value: I,
    configurable: !0
  }), a(I, "constructor", {
    value: b,
    configurable: !0
  }), b.displayName = V(I, T, "GeneratorFunction"), n.isGeneratorFunction = function(c) {
    var s = typeof c == "function" && c.constructor;
    return !!s && (s === b || (s.displayName || s.name) === "GeneratorFunction");
  }, n.mark = function(c) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(c, I) : (c.__proto__ = I, V(c, T, "GeneratorFunction")), c.prototype = Object.create(q), c;
  }, n.awrap = function(c) {
    return {
      __await: c
    };
  }, Ce(ae.prototype), V(ae.prototype, g, function() {
    return this;
  }), n.AsyncIterator = ae, n.async = function(c, s, d, y, v) {
    v === void 0 && (v = Promise);
    var S = new ae(D(c, s, d, y), v);
    return n.isGeneratorFunction(s) ? S : S.next().then(function(P) {
      return P.done ? P.value : S.next();
    });
  }, Ce(q), V(q, T, "Generator"), V(q, m, function() {
    return this;
  }), V(q, "toString", function() {
    return "[object Generator]";
  }), n.keys = function(c) {
    var s = Object(c), d = [];
    for (var y in s) d.push(y);
    return d.reverse(), function v() {
      for (; d.length; ) {
        var S = d.pop();
        if (S in s) return v.value = S, v.done = !1, v;
      }
      return v.done = !0, v;
    };
  }, n.values = Ne, ye.prototype = {
    constructor: ye,
    reset: function(c) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(Ie), !c) for (var s in this) s.charAt(0) === "t" && t.call(this, s) && !isNaN(+s.slice(1)) && (this[s] = e);
    },
    stop: function() {
      this.done = !0;
      var c = this.tryEntries[0].completion;
      if (c.type === "throw") throw c.arg;
      return this.rval;
    },
    dispatchException: function(c) {
      if (this.done) throw c;
      var s = this;
      function d(U, ie) {
        return S.type = "throw", S.arg = c, s.next = U, ie && (s.method = "next", s.arg = e), !!ie;
      }
      for (var y = this.tryEntries.length - 1; y >= 0; --y) {
        var v = this.tryEntries[y], S = v.completion;
        if (v.tryLoc === "root") return d("end");
        if (v.tryLoc <= this.prev) {
          var P = t.call(v, "catchLoc"), k = t.call(v, "finallyLoc");
          if (P && k) {
            if (this.prev < v.catchLoc) return d(v.catchLoc, !0);
            if (this.prev < v.finallyLoc) return d(v.finallyLoc);
          } else if (P) {
            if (this.prev < v.catchLoc) return d(v.catchLoc, !0);
          } else {
            if (!k) throw Error("try statement without catch or finally");
            if (this.prev < v.finallyLoc) return d(v.finallyLoc);
          }
        }
      }
    },
    abrupt: function(c, s) {
      for (var d = this.tryEntries.length - 1; d >= 0; --d) {
        var y = this.tryEntries[d];
        if (y.tryLoc <= this.prev && t.call(y, "finallyLoc") && this.prev < y.finallyLoc) {
          var v = y;
          break;
        }
      }
      v && (c === "break" || c === "continue") && v.tryLoc <= s && s <= v.finallyLoc && (v = null);
      var S = v ? v.completion : {};
      return S.type = c, S.arg = s, v ? (this.method = "next", this.next = v.finallyLoc, Z) : this.complete(S);
    },
    complete: function(c, s) {
      if (c.type === "throw") throw c.arg;
      return c.type === "break" || c.type === "continue" ? this.next = c.arg : c.type === "return" ? (this.rval = this.arg = c.arg, this.method = "return", this.next = "end") : c.type === "normal" && s && (this.next = s), Z;
    },
    finish: function(c) {
      for (var s = this.tryEntries.length - 1; s >= 0; --s) {
        var d = this.tryEntries[s];
        if (d.finallyLoc === c) return this.complete(d.completion, d.afterLoc), Ie(d), Z;
      }
    },
    catch: function(c) {
      for (var s = this.tryEntries.length - 1; s >= 0; --s) {
        var d = this.tryEntries[s];
        if (d.tryLoc === c) {
          var y = d.completion;
          if (y.type === "throw") {
            var v = y.arg;
            Ie(d);
          }
          return v;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(c, s, d) {
      return this.delegate = {
        iterator: Ne(c),
        resultName: s,
        nextLoc: d
      }, this.method === "next" && (this.arg = e), Z;
    }
  }, n;
}
function bn(e) {
  return Er(e) || Dr(e) || jr(e) || Ar();
}
function Wr(e, n) {
  if (typeof e != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var t = i.call(e, n || "default");
    if (typeof t != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function An(e) {
  var n = Wr(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
function Me(e) {
  "@babel/helpers - typeof";
  return Me = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Me(e);
}
function jr(e, n) {
  if (e) {
    if (typeof e == "string") return $e(e, n);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? $e(e, n) : void 0;
  }
}
function un(e) {
  try {
    return e();
  } catch (n) {
    return console.error("[hybrid/jssdk] safeInvokeNoArg error", n), console.trace("safeInvokeNoArg trace"), null;
  }
}
function kr(e, n) {
  if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function Ur(e, n) {
  for (var i = 0; i < n.length; i++) {
    var t = n[i];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, jn(t.key), t);
  }
}
function Lr(e, n, i) {
  return n && Ur(e.prototype, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Wn(e, n, i) {
  return (n = jn(n)) in e ? Object.defineProperty(e, n, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = i, e;
}
function Vn(e, n) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    n && (t = t.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, t);
  }
  return i;
}
function K(e) {
  for (var n = 1; n < arguments.length; n++) {
    var i = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Vn(Object(i), !0).forEach(function(t) {
      Wn(e, t, i[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Vn(Object(i)).forEach(function(t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
    });
  }
  return e;
}
function Hr(e, n) {
  if (Me(e) != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var t = i.call(e, n || "default");
    if (Me(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function jn(e) {
  var n = Hr(e, "string");
  return Me(n) == "symbol" ? n : n + "";
}
function Qe(e) {
  "@babel/helpers - typeof";
  return Qe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Qe(e);
}
var We = "1.14.8", je = "2024-09-09 3:38:44 PM";
function Ye(e) {
  for (var n, i = arguments.length, t = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) t[a - 1] = arguments[a];
  (n = console).log.apply(n, ["[".concat(ln(), "] ").concat(e)].concat(t));
}
function le(e) {
  for (var n, i = arguments.length, t = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) t[a - 1] = arguments[a];
  (n = console).warn.apply(n, ["[".concat(ln(), "] ").concat(e)].concat(t, ["stack"]));
}
function H(e) {
  for (var n, i = new Error().stack, t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++) a[l - 1] = arguments[l];
  (n = console).error.apply(n, ["[".concat(ln(), "] ").concat(e)].concat(a, ["stack", i]));
}
function be() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Date();
  return "".concat(e.getFullYear(), "-").concat(("0" + e.getDate()).slice(-2), "-").concat(("0" + (e.getMonth() + 1)).slice(-2), " ").concat(("0" + e.getHours()).slice(-2), ":").concat(("0" + e.getMinutes()).slice(-2), ":").concat(("0" + e.getSeconds()).slice(-2), ".").concat(e.getMilliseconds());
}
function ln() {
  return "[".concat(We, "(").concat(je, "]) ").concat(be());
}
function Fr() {
  return "id" + Math.random().toString(16).slice(2);
}
function Rn() {
  return Math.random().toString(16).slice(2);
}
function kn(e, n) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, t = e, a, l;
  if (t || (t = {}), n) for (a in n) (i || !(a in t)) && (l = n[a], t[a] = l && l.constructor === Object ? kn(t[a], l, i) : l);
  return t;
}
function Br(e) {
  try {
    return JSON.parse(e);
  } catch (n) {
    H("safeJsonParse got a invalid json string [".concat(e, "] ").concat(n));
  }
  return {};
}
function En(e) {
  var n = e.replace(/\./g, "\\.");
  return n = n.replace(/\*/g, ".*"), n = "^" + n + "$", new RegExp(n);
}
function _n(e, n) {
  var i = new URL(e).hostname;
  return n.some(function(t) {
    return t.test(i);
  });
}
function qe() {
}
function Mn(e, n) {
  for (var i in e) e[i] && (n[i] = e[i]);
}
var Jr = function(n) {
  var i;
  return !!((i = n.chrome) !== null && i !== void 0 && i.webview);
}, Xr = function(n) {
  return !!(n.chrome && n.webkit);
}, Zr = function(n) {
  return !!(!n.chrome && n.webkit);
}, Gr = function(n) {
  return !!n.android && !!n.android_config;
}, oe = {
  isAndroid: Gr,
  isWebView2: Jr,
  isCEF: Xr,
  isMacOSOrIOS: Zr
};
function qr() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  if (oe.isCEF(window)) {
    var i;
    return (n == null ? void 0 : n.linuxJSBridgeObject) || ((i = window.webkit) === null || i === void 0 || (i = i.messageHandlers) === null || i === void 0 ? void 0 : i.jsOCHelper);
  }
  if (oe.isWebView2(window)) {
    var t;
    return (n == null ? void 0 : n.windowJSBridgeObject) || ((t = window.chrome) === null || t === void 0 ? void 0 : t.webview);
  }
  if (oe.isMacOSOrIOS(window)) {
    var a, l;
    return (n == null ? void 0 : n.macOrIOSJSBridgeObject) || ((a = window.webkit) === null || a === void 0 || (a = a.messageHandlers) === null || a === void 0 ? void 0 : a.unifyJSObj) || ((l = window.webkit) === null || l === void 0 || (l = l.messageHandlers) === null || l === void 0 ? void 0 : l.jsOCHelper);
  }
  if (oe.isAndroid(window)) return (n == null ? void 0 : n.androidJSBridgeObject) || window.android;
  if (!e) {
    var m = "[hybrid/bridge] Not found jsbridge object, if you are in dev proxy mode, you can skip throw by set getInstance({ config: { softRegisterBridge: true } })! If you see this message in the prod, this is a bug.";
    throw H(m), Error(m);
  }
}
var Un = 60, Kr = 1, Ve = "*";
function xr(e) {
  return {
    jsCallId: e,
    returnCode: 0,
    result: "success, this is fake response for no response request"
  };
}
var Pn = /* @__PURE__ */ function() {
  function e() {
    kr(this, e), Wn(this, "handlers", void 0), this.handlers = [];
  }
  return Lr(e, [{
    key: "use",
    value: function(i) {
      return this.handlers.push(i), this.handlers.length - 1;
    }
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */
  }, {
    key: "eject",
    value: function(i) {
      return this.handlers[i] ? (this.handlers[i] = null, !0) : !1;
    }
    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */
  }, {
    key: "clear",
    value: function() {
      this.handlers && (this.handlers = []);
    }
    /**
     * return {Boolean} `true` if the interceptor fn was empty, `false` otherwise
     */
  }, {
    key: "empty",
    value: function() {
      return this.handlers.filter(function(i) {
        return i;
      }).length === 0;
    }
  }]);
}(), Cn = !1;
function Q() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = $r(e), i = qr(n.config.softRegisterBridge, n.platform), t = {}, a = {}, l = {}, m = {}, g = /* @__PURE__ */ new Map(), T = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new Map(), D, X, M = [], A = {}, pe = {
    info: qe,
    warn: qe,
    error: qe
  }, j = n.debug, Z = j.enable, me = j.output, b = K({}, Z && me ? me : pe), I = n.config.unifySDKMode ? "unifySdk" : "zoomSdk", ee = !window[I], re = ee ? "master_".concat(Rn()) : "sub_".concat(Rn()), W = [], q = {
    request: new Pn(),
    response: new Pn()
  };
  P();
  function Ce(r) {
    ae(Ve, r);
  }
  function ae(r, o) {
    var u = Array.isArray(r) ? r : [r];
    u.forEach(function(f) {
      var p = m[f];
      p ? p.push(o) : m[f] = [o];
    });
  }
  function Be(r) {
    ge(Ve, r);
  }
  function ge(r, o) {
    var u = Array.isArray(r) ? r : [r];
    u.forEach(function(f) {
      var p = m[f];
      if (p) {
        var w = p.indexOf(o);
        w !== -1 && (p.splice(w, 1), m[f] = p);
      }
    });
  }
  function se(r) {
    var o, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      isIOSSupport: !0,
      isAndroidSupport: !0,
      isMacSupport: !0,
      isWindowsSupport: !0,
      isLinuxSupport: !0
    }, f = r.functionName, p = f === void 0 ? "" : f, w = r.params, R = w === void 0 ? {} : w, O = r.timeout, C = O === void 0 ? n == null || (o = n.config) === null || o === void 0 ? void 0 : o.messageTimeout : O, Ae = r.raceMode, Ze = Ae === void 0 ? !1 : Ae, ve = r.needResponse, we = ve === void 0 ? !0 : ve, he = r.overWriteResponse, br = he === void 0 ? !1 : he, yn = r.moduleName, Vr = yn === void 0 ? "" : yn, Nn = r.noDelete, Rr = Nn === void 0 ? !1 : Nn, Se = {
      functionName: p,
      params: R,
      timeout: C,
      raceMode: Ze,
      needResponse: we,
      overWriteResponse: br,
      moduleName: Vr,
      noDelete: Rr
    };
    !p && r.apiName && (Se.apiName = r.apiName, Se.data = r.data);
    var L = y(Se);
    return L = JSON.parse(JSON.stringify(K(K({}, L), u))), L = Ie(L), new Promise(function(wn, hn) {
      Se.needResponse ? v(L, wn, hn) : (b.warn("%c The native client request(".concat(L.functionName || L.apiName, "__").concat(L.jsCallId, ") with needResponse:false."), "color: warn; font-weight:bold", Se), wn(xr(L.jsCallId)));
      var Sn = window.top !== window;
      if (b.info("".concat(Sn ? "Iframe" : "", " request %c").concat(L.functionName || L.apiName, "__").concat(L.jsCallId), "color:#909399; font-weight: bold", L), Sn)
        if (n.config.iframeSupport) window.top.postMessage({
          identityKey: n.config.iframeMessageIdentityKey,
          request: K({}, L)
        }, "*");
        else return hn(new Error("JSBridge does not support calls within iframes. If iframe support is needed, please set the iframeSupport parameter."));
      else {
        var Ge;
        (Ge = window[I]) === null || Ge === void 0 || Ge.postMessage(L);
      }
    });
  }
  function Ie(r) {
    if (q.request.empty()) return r;
    for (var o = r.functionName, u = r.apiName, f = r.params, p = r.data, w = q.request.handlers.filter(function(C) {
      return C;
    }), R = 0; R < w.length; R++) if (w[R]) {
      var O = w[R]({
        functionName: o,
        apiName: u,
        params: f,
        data: p
      });
      f = O == null ? void 0 : O.params, p = O == null ? void 0 : O.data, r.params && !f && b.warn("%cThe request interceptor returned empty parameters!!!", "color: yellow; font-weight: bold", "interceptor return", O), r.data && !p && b.warn("%cThe request interceptor returned empty data!!!", "color: yellow; font-weight: bold", "interceptor return", O);
    }
    return r.params && (r.params = f), r.data && (r.data = p), K({}, r);
  }
  function ye(r) {
    if (q.response.empty()) return r;
    for (var o = r, u = q.response.handlers.filter(function(p) {
      return p;
    }), f = 0; f < u.length; f++) u[f] && (o = u[f](o), o || b.warn("%cThe response interceptor should not return an empty response!!!", "color: yellow; font-weight: bold", "interceptor response", o));
    return o;
  }
  function Ne() {
    for (var r in l) clearTimeout(l[r]);
    l = {};
  }
  function c() {
    var r, o;
    t = {}, a = {}, T.clear(), g.clear(), V.clear(), (r = D) === null || r === void 0 || (o = r.destroy) === null || o === void 0 || o.call(r);
  }
  function s() {
    m = {};
  }
  function d(r) {
    try {
      if (i) {
        var o = r.iframeWindow;
        r.iframeWindow = null;
        var u = n.config.messageFormat === "string" ? JSON.stringify(r) : r;
        if (o && n.config.iframeSupport && (A[r.jsCallId] = o), r.raceMode) {
          var f = gr(r);
          g.has(f) ? g.get(f).push(r.jsCallId) : (T.set(r.jsCallId, f), g.set(f, [r.jsCallId]), i.postMessage(u));
        } else i.postMessage(u);
      } else b.warn(`%cFailed to post a message. The JS bridge object was not found.
!`, "color: yellow; font-weight: bold");
    } catch (p) {
      H("Failed to post a message.", p);
    }
  }
  function y(r) {
    var o, u, f;
    if (!r.functionName && !r.apiName) throw H("Invalid message format. The functionName/apiName is missing.", r), new Error("Invalid message format. The functionName/apiName is missing.");
    if (r.timeout !== void 0 && r.timeout < 0) throw H("Invalid message format. Timeout cannot be negative.", r), new Error("Invalid message format. Timeout cannot be negative.");
    return K(K({
      iframeWindow: null
    }, r), {}, {
      sdkName: I,
      timeout: (o = (u = r.timeout) !== null && u !== void 0 ? u : n == null || (f = n.config) === null || f === void 0 ? void 0 : f.messageTimeout) !== null && o !== void 0 ? o : Un,
      jsCallId: Fr()
    });
  }
  function v(r, o, u) {
    var f, p = Date.now();
    r.timeout && !r.noDelete && (f = setTimeout(function() {
      var w = "The native client did not respond to the API call (".concat(r.functionName || r.apiName, "__").concat(r.jsCallId, "). timeout is ").concat(r.timeout, " seconds");
      vr(r), window.top && window.top !== window && window.top.postMessage({
        identityKey: n.config.iframeMessageIdentityKey,
        purpose: "cleanTimeoutJsCall",
        timeoutJsCallId: r.jsCallId
      }, "*"), H(w, r), Sr({
        reject: u,
        errorMessage: w,
        jsCallId: r.jsCallId
      });
    }, r.timeout * 1e3), l[r.jsCallId] = f), V.set(r.jsCallId, u), S(r, f, function(w) {
      var R = n.config.longRequestSeconds, O = typeof w == "string" ? JSON.parse(w) : w;
      O = JSON.parse(JSON.stringify(O));
      var C = O;
      O.data && !O.jsCallId && (C = O.data), C = ye(C), C || u("[hybrid/bridge] callResponseInterceptor return a empty response, please check your response");
      var Ae = C, Ze = Ae.returnCode;
      if (o(C), De(r.jsCallId), f && clearTimeout(f), delete l[r.jsCallId], n.debug.enable) {
        var ve = Date.now(), we = parseFloat((ve - p).toFixed(2)), he = window.top !== window ? "iframe received " : "";
        R && we >= R * 1e3 ? b.warn("%c ".concat(we, "ms ").concat(he, " Slow API response ").concat(r.functionName || r.apiName, "__").concat(r.jsCallId, " requestTime: ").concat(be(new Date(p)), " responseTime: ").concat(be(new Date(ve))), "font-weight: bold", O) : b.info("".concat(we, "ms ").concat(he, " response %c").concat(r.functionName || r.apiName, "__").concat(r.jsCallId, "%c requestTime: ").concat(be(new Date(p)), " responseTime: ").concat(be(new Date(ve))), "color:#".concat(Ze === 0 ? "67C23A" : "F56C6C", ";font-weight: bold"), "", O);
      }
    });
  }
  function S(r, o, u) {
    if (t[r.jsCallId] = u, r.overWriteResponse) {
      var f = r.functionName || r.apiName;
      if (a[f]) {
        var p = a[f];
        b.info("remove call id: ", p.callID), clearTimeout(p.timerHandler), De(p.callID), r.overWriteResponse && mr(r);
      }
      a[f] = {
        callID: r.jsCallId,
        timerHandler: o
      };
    }
  }
  function P() {
    try {
      if (window[I] && !n.config.sharedBridge && !Cn) {
        var r;
        if (!n.config.softRegisterBridge) throw H("Failed to register SDK object for ".concat(I, ", as it already exists."), window.top !== window), new Error("Failed to register SDK object for ".concat(I, ", as it already exists."));
        if (((r = window[I]) === null || r === void 0 ? void 0 : r.constructor) !== Object) throw H("Failed to inject window.".concat(I, ". The window.").concat(I, " object should be a plain object.."), window[I]), new Error("Failed to inject window.".concat(I, ". The window.").concat(I, " object should be a plain object."));
      }
      n.config.iframeSupport && (window.top === window ? D = ie() : D = ce());
      var o = {
        native2js: ue,
        postJSMessage: se,
        postMessage: d,
        registerSubInstance: Je,
        unregisterSubInstance: Xe,
        isInstanceRegistered: $,
        buildInfo: {
          buildTime: je,
          version: We
        }
      };
      if (ee) {
        var u;
        b.info("%c start register master ".concat(I, "..."), "font-weight: bold", {
          sdkObject: window[I],
          sdkName: I,
          bridgeOptions: n
        }), n.config.softRegisterBridge || Cn ? (window[I] || (window[I] = {
          native2js: ue,
          registerSubInstance: Je,
          unregisterSubInstance: Xe,
          isInstanceRegistered: $,
          postJSMessage: se,
          postMessage: d,
          buildInfo: {
            buildTime: je,
            version: We
          }
        }), Mn(window[I], o), n.config.unifySDKMode || (window.unifySdk = {
          native2js: ue,
          registerSubInstance: Je,
          unregisterSubInstance: Xe,
          isInstanceRegistered: $,
          postJSMessage: se,
          postMessage: d,
          buildInfo: {
            buildTime: je,
            version: We
          }
        }, Mn(window.unifySdk, o))) : (Object.defineProperty(window, I, {
          value: o,
          writable: !1,
          enumerable: !1
        }), n.config.unifySDKMode || Object.defineProperty(window, "unifySdk", {
          value: o,
          writable: !1,
          enumerable: !1
        })), oe.isWebView2(window) && typeof ((u = window.chrome) === null || u === void 0 || (u = u.webview) === null || u === void 0 ? void 0 : u.addEventListener) == "function" && (X && window.chrome.webview.removeEventListener("message", X), window.chrome.webview.addEventListener("message", X = function(w) {
          w instanceof Event && w.data ? o.native2js(JSON.parse(JSON.stringify(w.data))) : o.native2js(w);
        })), b.info("%c register master ".concat(I, " successfully!"), "color: green; font-weight: bold", {
          sdkObject: window[I],
          unifySdkObject: window.unifySdk,
          sdkName: I,
          bridgeOptions: n
        }), k();
      } else {
        var f;
        b.info("%c start register sub ".concat(I, " (").concat(re, ")..."), "font-weight: bold", {
          sdkObject: window[I],
          sdkName: I,
          bridgeOptions: n
        }), (f = window[I]) === null || f === void 0 || f.registerSubInstance({
          instanceId: re,
          handleNativeResponse: ue,
          isJsCallIdFromThisInstance: ir,
          isThisInstanceRegisteredNotification: tr
        });
      }
    } catch (p) {
      b.error("%c register ".concat(I, " failed!"), "color: red; font-weight: bold", {
        error: p,
        sdkObject: window[I],
        sdkName: I,
        bridgeOptions: n
      });
    }
  }
  function k() {
    se({
      functionName: "webview.ready",
      params: {},
      needResponse: !1,
      raceMode: !0
    }), !n.config.allowPendingNotification && window.__unfiySdk_pending_notification && le("[hybrid/bridge] not allow to check pending message, but __unfiySdk_pending_ has message in it.");
  }
  function U() {
    if (n.config.allowPendingNotification) {
      var r;
      (r = window.__unfiySdk_pending_notification) === null || r === void 0 || r.forEach(function(o) {
        try {
          ue(o);
        } catch (u) {
          le("[hybrid/bridge] handle __unfiySdk_pending_notification error", u, o);
        }
      }), delete window.__unfiySdk_pending_notification;
    } else le("[hybrid/bridge] skip checkPendingNotification, due to allowPendingNotification was false");
  }
  function ie() {
    n.config.iframeAllowedOrigin.length || le("[hybrid] iframeSupport was true, but iframeAllowedOrigin is empty, please add origin in bridge config.");
    var r = n.config.iframeAllowedOrigin.map(En), o = function(f) {
      var p = f.data, w = f.origin;
      if (_n(f.origin, r) && (p == null ? void 0 : p.identityKey) === n.config.iframeMessageIdentityKey) {
        var R = p.request, O = p.purpose, C = p.timeoutJsCallId;
        O === "registerIframe" ? Or(f.source) : O === "unregisterIframe" ? Tr(f.source) : O === "cleanTimeoutJsCall" && C ? ar(C) : (R.needResponse && (R.iframeWindow = f.source), d(R));
      } else b.warn("[hybrid] Received a invalid message or message sent from invalid origin ".concat(w), f);
    };
    return window.removeEventListener("message", o), window.addEventListener("message", o), {
      destroy: function() {
        window.removeEventListener("message", o), D = null;
      }
    };
  }
  function ce() {
    if (!n.config.iframeAllowedOrigin.length) throw new Error("[hybrid] iframeSupport was true, but iframeAllowedOrigin is empty, please add origin in bridge config.iframeAllowedOrigin field or disable iframe support.");
    var r = n.config.iframeAllowedOrigin.map(En), o = function(f) {
      var p = f.data, w = f.origin;
      if (_n(f.origin, r) && (p == null ? void 0 : p.identityKey) === n.config.iframeMessageIdentityKey) {
        var R = p.response;
        ue(R);
      } else b.warn("[hybrid] got a message from invalid origin ".concat(w), f);
    };
    return window.removeEventListener("message", o), window.addEventListener("message", o), window.top.postMessage({
      identityKey: n.config.iframeMessageIdentityKey,
      purpose: "registerIframe"
    }, "*"), {
      destroy: function() {
        window.removeEventListener("message", o), window.top.postMessage({
          identityKey: n.config.iframeMessageIdentityKey,
          purpose: "unregisterIframe"
        }, "*"), D = null;
      }
    };
  }
  function $(r) {
    if (!ee) {
      var o = "[Bridge::isInstanceRegistered] can't call isInstanceRegistered on sub, current instanceId ".concat(r);
      throw H(o), new Error(o);
    }
    return W.some(function(u) {
      return u.instanceId === r;
    });
  }
  function Je(r) {
    var o;
    if (!ee) {
      var u = "[Bridge::registerSubInstance] can't register a instance to sub, current instanceId ".concat(re);
      throw H(u), new Error(u);
    }
    (o = window[I]) !== null && o !== void 0 && o.isInstanceRegistered(r.instanceId) ? le("[Bridge::registerSubInstance] instance ".concat(r.instanceId, " already registered!")) : (W.push(r), Ye("%c register sub ".concat(I, " ").concat(r.instanceId, " successfully!"), "color: green; font-weight: bold", W));
  }
  function Xe(r) {
    var o;
    if (!ee) {
      var u = "[Bridge::isInstanceRegistered] can't unregisterSubInstance on sub, current instanceId ".concat(r);
      throw H(u), new Error(u);
    }
    if ((o = window[I]) !== null && o !== void 0 && o.isInstanceRegistered(r)) {
      var f = W.findIndex(function(p) {
        return p.instanceId === r;
      });
      W.splice(f, 1), Ye("%c unregister sub ".concat(I, " ").concat(r, " successfully!"), "font-weight: bold", W);
    } else le("[Bridge::unregisterSubInstance] instance ".concat(r, " not registered!"));
  }
  function ir(r) {
    return !!t[r];
  }
  function tr(r) {
    return !!m[r] || !!m[Ve];
  }
  function or() {
    var r;
    (r = window[I]) === null || r === void 0 || r.unregisterSubInstance(re);
  }
  function gn() {
    M = M.filter(function(r) {
      return !r.closed;
    }), Object.keys(A).forEach(function(r) {
      var o = A[r];
      o.closed && delete A[r];
    });
  }
  function ar(r) {
    window.top === window && (A[r] && r && delete A[r], gn());
  }
  function ue(r) {
    if (gn(), !r || Qe(r) !== "object") {
      b.warn("Native client send a invalid response to jsbridge, ignore it!", r);
      return;
    }
    var o = cr(r), u = o.jsCallId;
    if (u) {
      if (t[u]) {
        var f, p;
        (f = (p = t)[u]) === null || f === void 0 || f.call(p, o);
      } else A[u] ? (Ir(A[u], r), delete A[u]) : Nr(u, r);
      hr(u, r);
    } else sr(o), yr(o), wr(o);
  }
  function sr(r) {
    var o, u = r == null || (o = r.result) === null || o === void 0 ? void 0 : o.notification;
    if (u) {
      b.info("%c".concat(u), "color: #0f00f0;font-weight:bold", r);
      var f = m[u], p = m[Ve];
      f != null && f.length ? In(f, r) : p != null && p.length || W.filter(function(w) {
        return w.isThisInstanceRegisteredNotification(u);
      }).length === 0 && b.warn("Received an unregistered notification: ".concat(u, ". Ignoring it."), r, f, m, m.notification), p && In(p, r);
    } else b.warn(`Failed to handle notification. The 'notification' field is missing in the response.
`, r);
  }
  function In(r, o) {
    r.slice().forEach(function(u) {
      try {
        u(o);
      } catch (f) {
        H("invoke handler error", {
          e: f,
          handler: u,
          message: o
        });
      }
    });
  }
  function cr(r) {
    if (pr(r)) return dr(r);
    var o = r;
    if ("jsCallId" in o) return o;
    if (ur(o)) {
      var u = lr(o);
      if (u.type === Yr) {
        var f, p;
        return K({
          jsCallId: (f = u.data.jsCallId) !== null && f !== void 0 ? f : "",
          returnCode: +((p = u.data.errorCode) !== null && p !== void 0 ? p : 0)
        }, u.data);
      } else if (u.type === zr && u.name === ei) {
        var w, R = u.data;
        return typeof R.eventData == "string" && (R.eventData = Br(R.eventData)), {
          jsCallId: "",
          returnCode: +((w = R.errorCode || R.eventData.returnCode) !== null && w !== void 0 ? w : 0),
          result: K({
            notification: R.eventName
          }, R)
        };
      } else throw b.error("Received a invalid appbridge response", o), new Error("UnifyJSSDK Received a invalid appbridge response");
    } else {
      if ("data" in o) return o.data;
      if (!o.jsCallId && "returnCode" in o && "result" in o && !("notification" in o)) return o;
      var O = fr(o);
      if (O) return O;
      throw b.error("Received a invalid response data struct", o), new Error("UnifyJSSDK Received a invalid response data struct");
    }
  }
  function ur(r) {
    if ("data" in r && "type" in r && (r.type === "event" && "name" in r || r.type === "apiResponse" && !("name" in r))) return !0;
    if ("data" in r && "data" in r.data && !("type" in r)) {
      var o = r.data;
      if (o.type === "event" && "name" in o || o.type === "apiResponse" && !("name" in o)) return !0;
    }
    return !1;
  }
  function lr(r) {
    if ("data" in r && "data" in r.data && !("type" in r)) return r.data;
    if ("data" in r && "type" in r) return r;
  }
  function fr(r) {
    return r.notification === "UnifyNotif_OnNetworkStateChanged" ? {
      jsCallId: "",
      returnCode: 0,
      result: K({}, r)
    } : !1;
  }
  function dr(r) {
    if (r.version === "v1.0") {
      if (r.type === "unifyNotification") return {
        jsCallId: "",
        returnCode: r.returnCode,
        errorMsg: r.errorMsg,
        result: {
          data: K({}, r.data),
          notification: r.notification
        }
      };
      if (r.type === "unifyResponse") return {
        jsCallId: r.jsCallId,
        returnCode: r.returnCode,
        errorMsg: r.errorMsg,
        result: K({}, r.data)
      };
    }
    throw new Error("[hybrid/jssdk] not supported new repsonse message version");
  }
  function pr(r) {
    return "type" in r && "version" in r ? r.type === "unifyNotification" || r.type === "unifyResponse" : !1;
  }
  function De(r) {
    delete t[r];
  }
  function mr(r) {
    var o = r.functionName || r.apiName;
    a[o] && delete a[o];
  }
  function vr(r) {
    try {
      n.config.onMessageTimeout && n.config.onMessageTimeout(r);
    } catch (o) {
      H("invoke message timeout callback error", o);
    }
  }
  function gr(r) {
    var o, u, f;
    return "F:".concat((o = r.functionName) !== null && o !== void 0 ? o : r.apiName, "_P:").concat(JSON.stringify((u = r.params) !== null && u !== void 0 ? u : {}), "_D:").concat(JSON.stringify((f = r.data) !== null && f !== void 0 ? f : {}));
  }
  function Ir(r, o) {
    if (n.config.iframeSupport) try {
      b.info("%c forward response message to iframe!", "font-weight: bold", o), r.closed || r.postMessage({
        identityKey: n.config.iframeMessageIdentityKey,
        response: o
      }, "*");
    } catch (u) {
      H("[hybrid] forward response message to iframe error", u);
    }
  }
  function yr(r) {
    n.config.iframeSupport && (b.info("%c forward notification to iframe!", "font-weight: bold", r), M.filter(function(o) {
      return !o.closed;
    }).forEach(function(o) {
      o.postMessage({
        identityKey: n.config.iframeMessageIdentityKey,
        response: r
      }, "*");
    }));
  }
  function Nr(r, o) {
    W.length && W.filter(function(u) {
      return u.isJsCallIdFromThisInstance(r);
    }).map(function(u) {
      u.handleNativeResponse(o);
    });
  }
  function wr(r) {
    W.length && W.map(function(o) {
      o.handleNativeResponse(r);
    });
  }
  function hr(r, o) {
    var u = T.get(r);
    if (u) {
      var f;
      (f = g.get(u)) === null || f === void 0 || f.forEach(function(p) {
        if (p !== r) {
          var w = JSON.parse(JSON.stringify(o));
          w.jsCallId = p, ue(w);
        }
      }), T.delete(r), g.delete(u);
    }
  }
  function Sr(r) {
    var o = r.reject, u = r.errorMessage, f = r.jsCallId, p = T.get(f), w = new Error(u);
    if (p) {
      var R = g.get(p) || [];
      R.forEach(function(O) {
        var C;
        delete l[O], De(O), (C = V.get(O)) === null || C === void 0 || C(w), V.delete(O);
      }), T.delete(f), g.delete(p), V.delete(f);
    } else delete l[f], V.delete(f), De(f), o(w);
  }
  function Or(r) {
    M.includes(r) || M.push(r);
  }
  function Tr(r) {
    var o = M.indexOf(r);
    o > -1 && M.splice(o, 1);
  }
  return {
    getInstance: Ln,
    registerNotificationHandler: Ce,
    checkPendingNotification: U,
    registerSpecificNotificationHandler: ae,
    unregisterNotificationHandler: Be,
    unregisterSpecificNotificationHandler: ge,
    unregisterInstance: or,
    postJsMessage: se,
    clearTimeHandler: Ne,
    clearAPICallback: c,
    clearNotificationHandler: s,
    interceptors: q
  };
}
function $r() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = kn({
    config: {
      messageTimeout: Un,
      longRequestSeconds: Kr,
      wildCardNotificationType: Ve,
      softRegisterBridge: !1,
      unifySDKMode: !1,
      messageFormat: "string",
      iframeSupport: !1,
      iframeAllowedOrigin: ["*"],
      iframeMessageIdentityKey: "ZM_UNIFY_HYBRID_MSG",
      sharedBridge: !0,
      allowPendingNotification: !0
    },
    debug: {
      enable: !0,
      output: {
        info: Ye,
        warn: le,
        error: H
      }
    }
  }, e);
  return n;
}
function Qr() {
  var e;
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return e || (e = Q(n));
  };
}
var Ln = Qr();
Q.getInstance = Ln;
var Yr = "apiResponse", zr = "event", ei = "zmOnAppBridgeEvent";
function _(e, n, i) {
  return Q.getInstance().postJsMessage(F({
    functionName: e,
    params: n
  }, i));
}
function He(e, n, i) {
  return Q.getInstance().postJsMessage(F({
    apiName: e,
    data: n
  }, i));
}
function Y(e, n) {
  Q.getInstance().registerSpecificNotificationHandler(e, n);
}
function z(e, n) {
  Q.getInstance().unregisterSpecificNotificationHandler(e, n);
}
function ni(e) {
  Q.getInstance().registerNotificationHandler(e);
}
function ri(e) {
  Q.getInstance().unregisterNotificationHandler(e);
}
var E = ".", N = {
  openLinkInBrowser: "common".concat(E, "openLinkInBrowser"),
  screenshot: "common".concat(E, "screenshot"),
  getNak: "auth".concat(E, "getNak"),
  getZak: "auth".concat(E, "getZak"),
  log: "common".concat(E, "log"),
  closeWebview: "webview".concat(E, "closeWebview"),
  confirmDestroy: "webview".concat(E, "confirmDestroy"),
  sendMessage: "webview".concat(E, "send"),
  reload: "webview".concat(E, "reload"),
  replyNotification: "webview".concat(E, "replyNotification"),
  openSysDlgSelectPath: "filesystem".concat(E, "openSysDlgSelectPath"),
  getSystemParam: "platform".concat(E, "getSystemParam"),
  startDownload: "download".concat(E, "startDownload"),
  pauseDownload: "download".concat(E, "pauseDownload"),
  resumeDownload: "download".concat(E, "resumeDownload"),
  cancelDownload: "download".concat(E, "cancelDownload"),
  getDownloadInfo: "download".concat(E, "getDownloadInfo"),
  clipboardRead: "clipboard".concat(E, "read"),
  clipboardWrite: "clipboard".concat(E, "write"),
  historyPush: "history".concat(E, "push"),
  historyConfirmPop: "history".concat(E, "confirmPop"),
  geolocation: "geolocation".concat(E, "getCurrentPosition"),
  request: "http".concat(E, "request")
}, Ke = {
  "auth.getNak": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    }
  },
  "auth.getZak": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.10"
    }
  },
  "clipboard.read": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    }
  },
  "clipboard.write": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    }
  },
  "common.openLinkInBrowser": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    }
  },
  "common.log": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.3.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.3.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.3.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.3.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.3.0"
    }
  },
  "common.screenshot": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.startDownload": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.pauseDownload": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.resumeDownload": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.cancelDownload": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.getDownloadInfo": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "download.onDownloadProgress": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "filesystem.openSysDlgSelectPath": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "geolocation.getCurrentPosition": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    }
  },
  "history.push": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    }
  },
  "history.confirmPop": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    }
  },
  "history.onHistoryChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    }
  },
  "history.offHistoryChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    }
  },
  "http.request": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  },
  "language.getClientLanguage": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    }
  },
  "network.onNetworkStateChanged": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "network.offNetworkStateChanged": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "platform.getSystemParam": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    }
  },
  "platform.onTimeZoneChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "NOT_SUPPORT"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    }
  },
  "platform.offTimeZoneChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "NOT_SUPPORT"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    }
  },
  "platform.onTimeFormatChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "NOT_SUPPORT"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "platform.offTimeFormatChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.0"
    },
    LINUX: {
      versionType: "NOT_SUPPORT"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "theme.getClientTheme": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    }
  },
  "theme.onClientSkinChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "theme.offClientSkinChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.0"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.closeWebview": {
    MAC: {
      versionType: "NOT_SUPPORT"
    },
    WINDOWS: {
      versionType: "NOT_SUPPORT"
    },
    LINUX: {
      versionType: "NOT_SUPPORT"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "5.17.0"
    }
  },
  "webview.onVisibilityChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.offVisibilityChange": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.0.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.onWebViewWillDestroy": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.offWebViewWillDestroy": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.onWebViewRestored": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.offWebViewRestored": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.confirmDestroy": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.1.5"
    },
    IOS: {
      versionType: "NOT_SUPPORT"
    },
    ANDROID: {
      versionType: "NOT_SUPPORT"
    }
  },
  "webview.send": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  },
  "webview.onReceiveMessage": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  },
  "webview.offReceiveMessage": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  },
  "webview.reload": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  },
  "webview.replyNotification": {
    MAC: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    WINDOWS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    LINUX: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    IOS: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    },
    ANDROID: {
      versionType: "MIN_VERSION",
      minVersion: "6.2.5"
    }
  }
}, J = /* @__PURE__ */ function(e) {
  return e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = -1] = "FAILED", e[e.REQUEST_PARAM_ERROR = 1001] = "REQUEST_PARAM_ERROR", e[e.WEBVIEW_MISSING_SYSTEM_PARAM = 2002] = "WEBVIEW_MISSING_SYSTEM_PARAM", e[e.CANCEL_SELECT_PATH = 2003] = "CANCEL_SELECT_PATH", e[e.CANCEL_SCREENSHOT = 1002] = "CANCEL_SCREENSHOT", e[e.WEBVIEW_NOT_FOCUS = 1003] = "WEBVIEW_NOT_FOCUS", e[e.ALREADY_IN_SCREENSHOT_PROGRESS = 1004] = "ALREADY_IN_SCREENSHOT_PROGRESS", e[e.SCREENSHOT_SIZE_EXCEED_LIMIT = 3001] = "SCREENSHOT_SIZE_EXCEED_LIMIT", e[e.SCREENSHOT_DEVICE_OCCUPIED = 3002] = "SCREENSHOT_DEVICE_OCCUPIED", e[e.SCREENSHOT_PERMISSION_DENIED = 3003] = "SCREENSHOT_PERMISSION_DENIED", e;
}(J || {});
function h(e) {
  var n = {};
  return new Promise(function(i, t) {
    Object.prototype.hasOwnProperty.call(n, e) ? n[e] ? i(!0) : t("".concat(e, " is not available in current client, please upgrade!")) : Fe().then(function(a) {
      var l = a.clientVersion, m = a.deviceOs, g = m.toUpperCase(), T = {};
      for (var V in Ke) {
        var D = V, X = Ke[D][g];
        T[D] = ii(l, X);
      }
      T[e] ? (n[e] = !0, i(!0)) : (n[e] = !1, t("".concat(e, " is not available in current client, please upgrade! version info: ") + JSON.stringify(Ke[e][g])));
    }).catch(function(a) {
      console.warn("This client not support isAvailable api, so default allow api call.", a), n[e] = !0, i(!0);
    });
  });
}
var Oe = {
  NOT_SUPPORT: "NOT_SUPPORT",
  RANGE: "RANGE",
  MULTI_RANGE: "MULTI_RANGE",
  MIN_VERSION: "MIN_VERSION",
  SPECIFIC: "SPECIFIC"
};
function ii(e, n) {
  var i = n;
  if (i)
    switch (i.versionType) {
      case Oe.NOT_SUPPORT:
        return !1;
      case Oe.SPECIFIC:
        return e === n.version;
      case Oe.MIN_VERSION:
        return Te(e, n.minVersion);
      case Oe.RANGE: {
        var t = n.range[0], a = n.range[0];
        return Te(e, t) && Te(a, e);
      }
      case Oe.MULTI_RANGE:
        return n.ranges.some(function(l) {
          var m = l[0], g = l[0];
          return Te(e, m) && Te(g, e);
        });
      default:
        return !1;
    }
  else
    return !1;
}
function Te(e, n) {
  return ti(e, n) >= 0;
}
function ti(e, n) {
  for (var i = function(V) {
    return V.split(".").map(Number);
  }, t = i(e), a = i(n), l = 0; l < Math.max(t.length, a.length); l++) {
    var m = t[l] || 0, g = a[l] || 0;
    if (m < g)
      return -1;
    if (m > g)
      return 1;
  }
  return 0;
}
function G(e) {
  var n = e.errorCode, i = e.apiName, t = e.message;
  return "[".concat(i, "] Error(").concat(n, "): ").concat(t);
}
function Fe() {
  return ze.apply(this, arguments);
}
function ze() {
  return ze = Le(/* @__PURE__ */ ne().mark(function e() {
    var n, i, t;
    return ne().wrap(function(l) {
      for (; ; ) switch (l.prev = l.next) {
        case 0:
          if (!((n = window.unifyConfig) !== null && n !== void 0 && n.systemParam)) {
            l.next = 4;
            break;
          }
          return l.abrupt("return", window.unifyConfig.systemParam);
        case 4:
          if (typeof ((i = window.android_config) === null || i === void 0 ? void 0 : i.getSystemParam) != "function") {
            l.next = 8;
            break;
          }
          return l.abrupt("return", JSON.parse(window.android_config.getSystemParam()));
        case 8:
          return l.next = 10, _(N.getSystemParam, {}, {
            timeout: 3
          });
        case 10:
          if (t = l.sent, !(t && !t.returnCode)) {
            l.next = 15;
            break;
          }
          return l.abrupt("return", t.result);
        case 15:
          return l.abrupt("return", Promise.reject(G({
            errorCode: J.WEBVIEW_MISSING_SYSTEM_PARAM,
            apiName: N.getSystemParam,
            message: "Failed to get getSystemParam from webview"
          })));
        case 16:
        case "end":
          return l.stop();
      }
    }, e);
  })), ze.apply(this, arguments);
}
var Hn = "UnifyNotify_OnTimeZoneChange", Re = [], en = !1, Fn = function(n) {
  var i = n.returnCode, t = n.result;
  if (i === 0) {
    var a, l = t.timezone, m = t.timeZoneOffset;
    Re.forEach(function(g) {
      un(function() {
        return g({
          timezone: l,
          timeZoneOffset: m
        });
      });
    }), (a = window.unifyConfig) !== null && a !== void 0 && a.systemParam && (window.unifyConfig.systemParam.timeZone = l, window.unifyConfig.systemParam.timeZoneOffset = m);
  } else
    console.warn("onTimeZoneInfoChangeHandler failed", n);
};
function oi(e) {
  return h("platform.onTimeZoneChange").then(function() {
    Re.push(e), en || (en = !0, Y(Hn, Fn));
  });
}
function ai(e) {
  return h("platform.offTimeZoneChange").then(function() {
    Re = Re.filter(function(n) {
      return n !== e;
    }), Re.length === 0 && (z(Hn, Fn), en = !1);
  });
}
var nn = !1, Ee = [], Bn = "UnifyNotify_OnTimeFormatChange", Jn = function(n) {
  var i = n.returnCode, t = n.result;
  if (i === 0) {
    var a, l = t.is24TimeFormat;
    Ee.forEach(function(m) {
      un(function() {
        return m(n);
      });
    }), (a = window.unifyConfig) !== null && a !== void 0 && a.systemParam && (window.unifyConfig.systemParam.is24TimeFormat = l);
  } else
    console.warn("onTimeFormatChangeHandler failed", n);
};
function si(e) {
  return h("platform.onTimeFormatChange").then(function() {
    Ee.push(e), nn || (nn = !0, Y(Bn, Jn));
  });
}
function ci(e) {
  return h("platform.onTimeFormatChange").then(function() {
    Ee = Ee.filter(function(n) {
      return n !== e;
    }), Ee.length === 0 && (z(Bn, Jn), nn = !1);
  });
}
const ui = {
  getSystemParam: Fe,
  onTimeZoneChange: oi,
  offTimeZoneChange: ai,
  onTimeFormatChange: si,
  offTimeFormatChange: ci
};
function li() {
  return rn.apply(this, arguments);
}
function rn() {
  return rn = Le(/* @__PURE__ */ ne().mark(function e() {
    var n, i, t, a, l;
    return ne().wrap(function(g) {
      for (; ; ) switch (g.prev = g.next) {
        case 0:
          return g.prev = 0, g.next = 3, Fe();
        case 3:
          return n = g.sent, g.abrupt("return", n.clientTheme);
        case 7:
          if (g.prev = 7, g.t0 = g.catch(0), console.warn("[hybrid/jssdk] getSystemParam failed, fallback to window.matchMedia", g.t0), !((i = (t = window).matchMedia) !== null && i !== void 0 && (i = i.call(t, "(prefers-color-scheme: dark)")) !== null && i !== void 0 && i.matches)) {
            g.next = 12;
            break;
          }
          return g.abrupt("return", "dark");
        case 12:
          if (!((a = (l = window).matchMedia) !== null && a !== void 0 && (a = a.call(l, "(prefers-color-scheme: light)")) !== null && a !== void 0 && a.matches)) {
            g.next = 14;
            break;
          }
          return g.abrupt("return", "light");
        case 14:
          return g.abrupt("return", "light");
        case 15:
        case "end":
          return g.stop();
      }
    }, e, null, [[0, 7]]);
  })), rn.apply(this, arguments);
}
function fi(e) {
  Gn(e);
}
function di(e) {
  qn(e);
}
var Xn = "UnifyNotif_OnClientSkinChange", _e = [], tn = !1, Zn = function(n) {
  var i = n.returnCode, t = n.result;
  if (i === 0) {
    var a = t.skin, l = t.theme;
    if (a) {
      var m;
      _e.forEach(function(g) {
        un(function() {
          return g({
            skin: a,
            theme: l
          });
        });
      }), (m = window.unifyConfig) !== null && m !== void 0 && m.systemParam && (a && (window.unifyConfig.systemParam.skin = a), l && (window.unifyConfig.systemParam.clientTheme = l));
    } else
      console.warn("OnClientSkinChange empty skin message", n);
  } else
    console.warn("OnClientSkinChange failed", n);
};
function Gn(e) {
  _e.push(e), tn || (tn = !0, Y(Xn, Zn));
}
function qn(e) {
  _e = _e.filter(function(n) {
    return n !== e;
  }), _e.length === 0 && (z(Xn, Zn), tn = !1);
}
const pi = {
  getClientTheme: li,
  registerThemeChangeListener: fi,
  unregisterThemeChangeListener: di,
  onClientSkinChange: Gn,
  offClientSkinChange: qn
};
var x = /* @__PURE__ */ function() {
  function e() {
    _r(this, e);
  }
  return Pr(e, null, [{
    key: "isCEF",
    value: function() {
      return oe.isCEF(window);
    }
  }, {
    key: "isWebView2",
    value: function() {
      return oe.isWebView2(window);
    }
  }, {
    key: "isIOS",
    value: function() {
      var i, t;
      return !!((["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
      navigator.userAgent.includes("Mac") && "ontouchend" in document) && !window.chrome && window.webkit) && !!((i = window.webkit) !== null && i !== void 0 && (i = i.messageHandlers) !== null && i !== void 0 && i.unifyJSObj || (t = window.webkit) !== null && t !== void 0 && (t = t.messageHandlers) !== null && t !== void 0 && t.jsOCHelper);
    }
  }, {
    key: "isMacOS",
    value: function() {
      var i, t;
      return !window.chrome && window.webkit && !e.isIOS() && !!((i = window.webkit) !== null && i !== void 0 && (i = i.messageHandlers) !== null && i !== void 0 && i.unifyJSObj || (t = window.webkit) !== null && t !== void 0 && (t = t.messageHandlers) !== null && t !== void 0 && t.jsOCHelper);
    }
  }, {
    key: "isWindows",
    value: function() {
      return e.isWebView2();
    }
  }, {
    key: "isLinux",
    value: function() {
      var i;
      return navigator.userAgent.toLowerCase().indexOf("linux") !== -1 && !!((i = window.webkit) !== null && i !== void 0 && (i = i.messageHandlers) !== null && i !== void 0 && i.jsOCHelper);
    }
  }, {
    key: "isAndroid",
    value: function() {
      return oe.isAndroid(window);
    }
  }]);
}();
function mi(e) {
  return h("webview.closeWebview").then(function() {
    return _(N.closeWebview, {
      clearCache: !!e
    });
  });
}
function vi() {
  return x.isAndroid() || x.isIOS() || x.isWindows() || x.isMacOS() || x.isLinux();
}
var te = /* @__PURE__ */ new Map();
function gi(e) {
  if (x.isMacOS() || x.isWindows()) {
    var n = function() {
      e(document.visibilityState);
    };
    te.set(e, n), document.addEventListener("visibilitychange", n);
  } else
    return h("webview.onVisibilityChange").then(function() {
      var i = function(a) {
        a.returnCode === 0 && e(a.result.visibilityState);
      };
      te.set(e, i), Y("UnifyNotif_OnWebviewVisibilityChange", i);
    });
}
function Ii(e) {
  if (x.isMacOS() || x.isWindows())
    te.has(e) && (document.removeEventListener("visibilitychange", te.get(e)), te.delete(e));
  else
    return h("webview.onVisibilityChange").then(function() {
      te.has(e) && (z("UnifyNotif_OnWebviewVisibilityChange", te.get(e)), te.delete(e));
    });
}
function yi(e) {
  return h("webview.onWebViewWillDestroy").then(function() {
    Y("UnifyNotify_OnWebViewWillDestroy", e);
  });
}
function Ni(e) {
  return h("webview.offWebViewWillDestroy").then(function() {
    z("UnifyNotify_OnWebViewWillDestroy", e);
  });
}
function wi(e) {
  return h("webview.onWebViewRestored").then(function() {
    Y("UnifyNotify_OnWebViewRestored", e), window.unifyConfig.webViewRestoredData && e(window.unifyConfig.webViewRestoredData);
  });
}
function hi(e) {
  return h("webview.offWebViewRestored").then(function() {
    z("UnifyNotify_OnWebViewRestored", e);
  });
}
function Si(e) {
  return h("webview.confirmDestroy").then(function() {
    return _(N.confirmDestroy, e);
  });
}
var on = !1, ke = [], Kn = "UnifyNotif_OnReceiveMessage";
function Oi(e, n) {
  return h("webview.send").then(function() {
    return _(N.sendMessage, F({}, e), n);
  });
}
function Ti(e) {
  ke.push(e), on || (on = !0, Y(Kn, e));
}
function bi(e) {
  ke = ke.filter(function(n) {
    return n !== e;
  }), ke.length === 0 && (z(Kn, e), on = !1);
}
function Vi() {
  return h("webview.reload").then(function() {
    return He(N.reload, {});
  });
}
function Ri(e) {
  return h("webview.replyNotification").then(function() {
    return _(N.replyNotification, F({}, e));
  });
}
const Ei = {
  closeWebview: mi,
  isInWebview: vi,
  onVisibilityChange: gi,
  offVisibilityChange: Ii,
  onWebViewWillDestroy: yi,
  offWebViewWillDestroy: Ni,
  onWebViewRestored: wi,
  offWebViewRestored: hi,
  confirmDestroy: Si,
  send: Oi,
  onReceiveMessage: Ti,
  offReceiveMessage: bi,
  reload: Vi,
  replyNotification: Ri
};
function _i() {
  return an.apply(this, arguments);
}
function an() {
  return an = Le(/* @__PURE__ */ ne().mark(function e() {
    var n;
    return ne().wrap(function(t) {
      for (; ; ) switch (t.prev = t.next) {
        case 0:
          return t.prev = 0, t.next = 3, Fe();
        case 3:
          return n = t.sent, t.abrupt("return", n.globalLang);
        case 7:
          return t.prev = 7, t.t0 = t.catch(0), console.warn("getSystemParam failed, fallback to navigator", navigator, t.t0), t.abrupt("return", window._zm_lang || navigator.language);
        case 11:
        case "end":
          return t.stop();
      }
    }, e, null, [[0, 7]]);
  })), an.apply(this, arguments);
}
const Mi = {
  getClientLanguage: _i
};
function Pi(e, n) {
  return h("common.openLinkInBrowser").then(function() {
    return e ? _(N.openLinkInBrowser, {
      url: e
    }, F(F({}, n), {}, {
      timeout: 1,
      needResponse: !1
    })) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.openLinkInBrowser,
      message: "url can't be empty!"
    }));
  });
}
function Ci(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, i = arguments.length > 2 ? arguments[2] : void 0;
  return h("common.log").then(function() {
    return e ? _(N.log, {
      message: e,
      logLevel: n
    }, i) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.log,
      message: "log message and logType can't be empty!"
    }));
  });
}
var xe = !1;
function Di() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
    isHideZoomWindowInScreenshot: !1
  };
  return h("common.screenshot").then(function() {
    return document.hasFocus() ? xe ? Promise.reject(G({
      errorCode: J.ALREADY_IN_SCREENSHOT_PROGRESS,
      apiName: N.screenshot,
      message: "screenshot is not allowed while a previous screenshot is still in progress."
    })) : (xe = !0, _(N.screenshot, e, {
      timeout: 0
    }).finally(function() {
      xe = !1;
    })) : Promise.reject(G({
      errorCode: J.WEBVIEW_NOT_FOCUS,
      apiName: N.screenshot,
      message: "Failed to take screenshot when webview not focus"
    }));
  });
}
const Ai = {
  openLinkInBrowser: Pi,
  log: Ci,
  screenshot: Di
};
function Wi() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
  return h("auth.getNak").then(function() {
    return _(N.getNak, e, n);
  });
}
function ji() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
  return h("auth.getZak").then(function() {
    return _(N.getZak, e, n);
  });
}
const ki = {
  getZak: ji,
  getNak: Wi
};
function xn(e, n) {
  return h("filesystem.openSysDlgSelectPath").then(function() {
    return e ? _(N.openSysDlgSelectPath, {
      filename: e
    }, n) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.openSysDlgSelectPath,
      message: "filename can't be empty!"
    }));
  });
}
const Ui = {
  openSysDlgSelectPath: xn
};
function Li(e) {
  return h("network.onNetworkStateChanged").then(function() {
    Y("UnifyNotif_OnNetworkStateChanged", e);
  });
}
function Hi(e) {
  return h("network.offNetworkStateChanged").then(function() {
    z("UnifyNotif_OnNetworkStateChanged", e);
  });
}
const Fi = {
  onNetworkStateChanged: Li,
  offNetworkStateChanged: Hi
};
function Bi(e, n) {
  return h("download.startDownload").then(function() {
    var i = e.url, t = e.useDefaultDownloadPath;
    return !t && (x.isMacOS() || x.isLinux() || x.isWindows()) ? xn(e.defaultFileName).then(function(a) {
      if (a.returnCode)
        return Promise.reject(G({
          errorCode: J.CANCEL_SELECT_PATH,
          apiName: N.startDownload,
          message: "pathId is empty!"
        }));
      var l = a.result.pathId;
      return l ? _(N.startDownload, F(F({}, e), {}, {
        pathId: l
      }), n) : Promise.reject(G({
        errorCode: J.REQUEST_PARAM_ERROR,
        apiName: N.startDownload,
        message: "pathId can't be empty!"
      }));
    }) : i ? _(N.startDownload, F(F({}, e), {}, {
      pathId: ""
    }), n) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.startDownload,
      message: "filename can't be empty!"
    }));
  });
}
function Ji(e, n) {
  return h("download.pauseDownload").then(function() {
    return e ? _(N.pauseDownload, {
      downloadId: e
    }, n) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.pauseDownload,
      message: "downloadId can't be empty!"
    }));
  });
}
function Xi(e, n) {
  return h("download.resumeDownload").then(function() {
    return e ? _(N.resumeDownload, {
      downloadId: e
    }, n) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.resumeDownload,
      message: "downloadId can't be empty!"
    }));
  });
}
function Zi(e, n) {
  return h("download.cancelDownload").then(function() {
    return e ? (fn(e), _(N.cancelDownload, {
      downloadId: e
    }, n)) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.cancelDownload,
      message: "downloadId can't be empty!"
    }));
  });
}
function Gi(e, n) {
  return h("download.getDownloadInfo").then(function() {
    return e ? _(N.getDownloadInfo, {
      downloadId: e
    }, n) : Promise.reject(G({
      errorCode: J.REQUEST_PARAM_ERROR,
      apiName: N.getDownloadInfo,
      message: "downloadId can't be empty!"
    }));
  });
}
function qi(e, n) {
  Object.keys(fe).length === 0 && Y("UnifyNotif_OnDownloadUpdate", $n), fe[e] = function(i) {
    try {
      n(i);
    } catch (t) {
      console.error("hybrid.download.onDownloadProgress callback failed.", t);
    }
  };
}
var fe = {};
function $n(e) {
  var n = e.returnCode, i = e.result, t = i.downloadId, a = i.percent;
  fe[t] && fe[t](e), (n !== 0 || a === 100) && fn(t);
}
function fn(e) {
  fe[e] && delete fe[e], Object.keys(fe).length === 0 && z("UnifyNotif_OnDownloadUpdate", $n);
}
const Ki = {
  startDownload: Bi,
  pauseDownload: Ji,
  resumeDownload: Xi,
  cancelDownload: Zi,
  getDownloadInfo: Gi,
  onDownloadProgress: qi,
  offDownloadProgress: fn
};
function xi() {
  return h("clipboard.read").then(function() {
    return _(N.clipboardRead, {});
  });
}
function $i(e) {
  return h("clipboard.write").then(function() {
    return _(N.clipboardWrite, F({}, e));
  });
}
const Qi = {
  read: xi,
  write: $i
};
var Pe = !1, dn = /* @__PURE__ */ new Set(), pn = /* @__PURE__ */ new Set(), B = /* @__PURE__ */ new Map(), mn, de = /* @__PURE__ */ new Map();
function Yi(e) {
  return sn.apply(this, arguments);
}
function sn() {
  return sn = Le(/* @__PURE__ */ ne().mark(function e(n) {
    var i;
    return ne().wrap(function(a) {
      for (; ; ) switch (a.prev = a.next) {
        case 0:
          if (!Pe) {
            a.next = 3;
            break;
          }
          return console.warn("[hybrid.appBridge] skip config, appBridge already configed, please call reset() then re-config!"), a.abrupt("return");
        case 3:
          return Pe = !0, n.log && rt(n), i = ["zmAppBridgePub", "zmAppBridgeSub", "zmOnAppBridgeEvent"], n.js_api_lists && (i = Array.from(/* @__PURE__ */ new Set([].concat(bn(i), bn(n.js_api_lists))))), et({
            js_api_lists: i
          }), nt(n), ni(Yn), a.abrupt("return", zi(n).then(function(l) {
            if (l.returnCode === 0)
              return l;
            throw new Error("[hybrid.appBridge] config app bridge failed, please check your subscribe config");
          }).catch(function(l) {
            throw Qn(), l;
          }));
        case 11:
        case "end":
          return a.stop();
      }
    }, e);
  })), sn.apply(this, arguments);
}
function zi(e) {
  return e.subscribe.forEach(function(n) {
    var i = n.eventNames;
    i == null || i.forEach(function(t) {
      dn.add(t);
    });
  }), He("zmAppBridgeSub", {
    data: e.subscribe
  });
}
function et(e) {
  return console.log("[hybrid.appBridge] config js_api_lists", e), He("config", e);
}
function nt(e) {
  var n;
  (n = e.ignoreEvents) === null || n === void 0 || n.forEach(function(i) {
    pn.add(i);
  }), e.onAppEventNotified && (mn = e.onAppEventNotified);
}
function rt(e) {
  Q.getInstance({
    debug: e.log
  });
}
function Qn() {
  Pe && (Pe = !1, ri(Yn), dn.clear(), pn.clear(), B.clear(), mn = function() {
  }, de.clear());
}
function it(e) {
  var n = e.service;
  if (!Pe)
    throw new Error("[Hybrid.appBridge] App bridge is not configured, please call config() first!");
  if (!n)
    throw new Error("[Hybrid.appBridge] App bridge getService got a empty service [".concat(n, "]!"));
  var i = {};
  return i[n] || (i[n] = {
    pub: function(a) {
      var l = a.action, m = a.params, g = m === void 0 ? {} : m, T = a.timeout, V = T === void 0 ? 30 * 1e3 : T, D = a.needResponse, X = D === void 0 ? !0 : D, M = at(), A = JSON.stringify({
        action: l,
        params: g,
        jsCallId: M
      }), pe = new Promise(function(j, Z) {
        B.set(M, {
          resolve: j,
          reject: Z
        });
      });
      return tt({
        service: n,
        action: l,
        jsCallId: M,
        timeout: V
      }), ot({
        jsCallId: M,
        needResponse: X
      }), He("zmAppBridgePub", {
        data: A,
        service: n
      }).then(function(j) {
        j && j.returnCode !== 0 && zn(M, j);
      }).catch(function(j) {
        B.get(M).reject(j);
      }), pe;
    }
  }), i[n];
}
function tt(e) {
  var n = e.service, i = e.action, t = e.jsCallId, a = e.timeout;
  if (a) {
    var l = setTimeout(function() {
      var m;
      console.warn("[hybrid.appBridge] Timeout: The native client did not provide a response to the App Bridge call, service:".concat(n, " action:").concat(i)), (m = B.get(t)) === null || m === void 0 || m.reject(new Error("[hybrid/jsbridge]AppBridge timeout ".concat(JSON.stringify({
        returnCode: -100,
        errorCode: -100
        /* CALL_SDK_TIME_OUT */
      })))), B.delete(t), vn(t);
    }, a);
    de.set(t, l);
  }
}
function ot(e) {
  var n = e.jsCallId, i = e.needResponse;
  if (!i) {
    var t;
    (t = B.get(n)) === null || t === void 0 || t.resolve({
      returnCode: 0,
      errorCode: 0
      /* SUCCESS */
    }), B.delete(n);
  }
}
function at() {
  return "id" + Math.random().toString(16).slice(2);
}
var Yn = function(n) {
  var i = n.returnCode, t = n.result, a = n.jsCallId;
  if (i === 0) {
    var l = t.eventName, m = t.eventData;
    if (dn.has(l) && (typeof m == "string" && (m = ut(m)), m)) {
      var g = m, T = g.jsCallId, V = g.result;
      if (T && !pn.has(l)) {
        var D = V || {}, X = D.reqId;
        X ? st(T, X) : Dn(T, m);
      } else {
        var M, A = ct(m);
        A && Dn(A, m), (M = mn) === null || M === void 0 || M({
          eventName: l,
          eventData: m
        });
      }
    }
  } else
    zn(a, n);
};
function Dn(e, n) {
  var i;
  (i = B.get(e)) === null || i === void 0 || i.resolve(n), B.delete(e), vn(e);
}
function zn(e, n) {
  var i;
  (i = B.get(e)) === null || i === void 0 || i.reject(new Error("[hybri/jssdk]AppBridge ErrorResponse ".concat(JSON.stringify(n)))), B.delete(e), vn(e);
}
function st(e, n) {
  B.has(e) && (B.set(n, B.get(e)), de.set(n, de.get(e)), de.delete(e), B.delete(e));
}
function ct(e) {
  var n = e.reqId, i = e.req_id;
  return n || i;
}
function ut(e) {
  try {
    return JSON.parse(e);
  } catch (n) {
    console.warn("Parse error, invalid json ".concat(e, " ").concat(n));
  }
  return null;
}
function vn(e) {
  clearTimeout(de.get(e)), de.delete(e);
}
const lt = {
  config: Yi,
  reset: Qn,
  getService: it
};
var cn = !1, Ue = [];
function ft(e) {
  return h("history.push").then(function() {
    return _(N.historyPush, F({}, e));
  });
}
function dt(e) {
  return h("history.confirmPop").then(function() {
    return _(N.historyConfirmPop, F({}, e));
  });
}
function er(e) {
  Ue.push(e), cn || (cn = !0, Y(rr, e));
}
function nr(e) {
  Ue = Ue.filter(function(n) {
    return n !== e;
  }), Ue.length === 0 && (z(rr, e), cn = !1);
}
var rr = "UnifyNotif_OnHistoryPopChange";
function pt(e) {
  er(e);
}
function mt(e) {
  nr(e);
}
const vt = {
  push: ft,
  confirmPop: dt,
  registerHistoryPopListener: pt,
  unregisterHistoryPopListener: mt,
  onHistoryChange: er,
  offHistoryChange: nr
};
function gt() {
  return h("geolocation.getCurrentPosition").then(function() {
    return _(N.geolocation, {});
  });
}
const It = {
  getCurrentPosition: gt
};
function yt(e, n) {
  var i = e.url, t = e.method, a = t === void 0 ? "GET" : t;
  return i ? _(N.request, F(F({}, e), {}, {
    method: a
  }), n) : Promise.reject(G({
    errorCode: J.REQUEST_PARAM_ERROR,
    apiName: N.request,
    message: "url can't be empty!"
  }));
}
const Nt = {
  request: yt
};
var wt = "1.14.8", ht = "2024-09-09 3:38:44 PM";
const St = {
  theme: pi,
  auth: ki,
  language: Mi,
  platform: ui,
  webview: Ei,
  bridge: Q,
  common: Ai,
  filesystem: Ui,
  network: Fi,
  download: Ki,
  clipboard: Qi,
  appBridge: lt,
  history: vt,
  geolocation: It,
  http: Nt,
  isAvailable: h,
  buildInfo: {
    buildTime: ht,
    version: wt
  }
};
export {
  St as default
};
//# sourceMappingURL=hybrid-jssdk.es.js.map
